import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';

import {ModalConfirmationComponent} from 'shared/modals/modal-confirmation/modal-confirmation.component';
import {Question} from 'shared/models/questions/question';
import {QuestionType} from 'shared/models/questions/question-type';
import {SearchBarComponent} from 'shared/search-bar/search-bar.component';
import {QuestionsOverviewService} from './services/questions-overview.service';

@Component({
  selector: 'questions-overview',
  templateUrl: './questions-overview.component.html',
  styleUrls: ['./questions-overview.component.css'],
})
export class QuestionsOverviewComponent implements OnInit {

  public questionTypes: Array<QuestionType>;
  public questionType: string;
  private questions: Array<Question> = [];
  public filteredQuestions: Array<Question> = [];
  public fieldsToSearch: Array<Array<string>> = [];
  public currentPage: Event;

  @ViewChild('deleteModal') private deleteModal: ModalConfirmationComponent;

  constructor(private questionsOverviewService: QuestionsOverviewService,
              private router: Router) {

    this.questions = [];
    this.questionTypes = [
      {name: 'buttonList', prettyName: 'Button Liste'},
      {name: 'energylevel', prettyName: 'Energielevel'},
      {name: 'message', prettyName: 'Nachricht'},
      {name: 'multislider', prettyName: 'Multi-Slider'},
      {name: 'performancelevel', prettyName: 'Performancelevel'},
      {name: 'rating', prettyName: 'Rating'},
      {name: 'slider', prettyName: 'Slider'},
      {name: 'yesno', prettyName: 'Ja/Nein'},
    ];
    this.questionType = 'all';
    this.sortQuestionTypes();
  }

  public ngOnInit(): void {
    this.questionsOverviewService.getQuestions()
      .subscribe((questions: Array<Question>) => {
        this.questions = questions;
        this.filteredQuestions = questions;
        this.prepareFieldsToSearch();
      });
  }

  public editQuestion(id: string): void {
    this.router.navigate(['questions', 'details', {questionId: id}]);
  }

  public createQuestion(): void {
    this.router.navigateByUrl('questions/details');
  }

  public deleteQuestion(id: string): void {
    this.questionsOverviewService.deleteQuestion(id)
      .subscribe(() => {
        const index: number = this.questions.findIndex((question: Question) => {
          return question._id === id;
        });

        if (index > -1) {
          this.questions.splice(index, 1);
        }
      });
  }

  public showDeleteModal(id: string): void {
    const questionName: string = this.getQuestionById(id).title.de;
    const content: string = `Sind Sie sicher, dass Sie die Frage "${questionName}" löschen möchten?`;

    this.deleteModal.setContent(content)
      .setEventData(id)
      .show();
  }

  public get filteredQuestionsByQuestionType(): Array<Question> {
    return this.questions.filter((question) => {
      return this.filterByQuestionType(question);
    });
  }

  public filterQuestions(eventQuestions: Array<Question>): void {
    this.filteredQuestions = eventQuestions;
  }

  public prepareFieldsToSearch(): void {
    this.fieldsToSearch = [];
    this.filteredQuestionsByQuestionType.forEach((question) => {
      this.fieldsToSearch.push([
        question.description.de.toLowerCase(),
        question.title.de.toLowerCase(),
      ]);
    });
  }

  private filterByQuestionType(question: Question): boolean {
    if (this.questionType === 'all') {
      return true;
    }

    return this.questionType === question.type.name;
  }

  private getQuestionById(id: string): Question {
    return this.questions.find((question: Question) => {
      return question._id === id;
    });
  }

  private sortQuestionTypes(): void {
    this.questionTypes.sort((leftQuestionType: QuestionType, rightQuestionType: QuestionType) => {
      if (leftQuestionType.prettyName < rightQuestionType.prettyName) {
        return -1;
      }

      if (leftQuestionType.prettyName > rightQuestionType.prettyName) {
        return 1;
      }

      return 0;
    });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/questions/questions-overview/questions-overview.component.ts